module.exports = __webpack_public_path__ + "assets/img/BET365.fa9f699f.png";